import * as React from "react"
import {useSignal} from "@preact/signals-react";
import {Box} from "@mui/material";
import { AlertSeeker } from "@ui-seeker/core"

export default function PricingMarketTableWarningLimit() {

	const isOpen = useSignal(true)

	return <Box sx={{ width: 1, py: 1 }}>
		<AlertSeeker
			isOpen={isOpen.value}
			severity="warning"
			controller={() => isOpen.value = !isOpen.value}
			title="Over 1000 Results Found"
			open={true}
		>
			With over 1000 results found, we advise fine-tuning your filters to optimize performance and pinpoint your search
		</AlertSeeker>
	</Box>
    
}
